import dissocPath from 'ramda/src/dissocPath'
import { CLEAR_EMBEDDED_DATA } from 'root/src/client/logic/embedded/actionIds'

export default {
	[CLEAR_EMBEDDED_DATA]: (state, { moduleId }) => dissocPath(['embedded', moduleId], state),
}
